import { useEffect, useState } from 'react'

import { ActionIconEnum } from 'common/enums/ActionIcon'
import { PageTitles } from 'common/enums/PageTitles'
import { useNavBar } from 'hooks/useNavBar'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import { useHistory } from 'react-router-dom'
import { Separator } from 'components'
import { Button, Flex, formatToBRL } from 'components/InterUI/InterUI'
import { Icons } from 'utils/icons'
import useBoundState from 'store'
import { useFilterTicketsToRedeem } from 'hooks/useFilterTicketsToRedeem'

import { Text } from '@interco/inter-ui/components/Text'

import * as S from './RedeemValue.styles'
import { analyticsRedeemLoad, analyticsRedeemValueTag } from './RedeemValue.tags'
import { RepurchaseBottomSheet } from './RepurchaseChanceBottomSheet'

export const RedeemValue = () => {
  const history = useHistory()
  const tickets = useBoundState((state) => state.tickets)
  const redeemValue = useBoundState((state) => state.redeemValue)
  const monitoring = useBoundState((state) => state.monitoring)

  const [showRepurchaseChanceBS, setShowRepurchaseChanceBS] = useState(false)

  useNavBar({
    navbarTitle: PageTitles.REDEEM_VALUE,
    actionIcons: {
      leftIcon: ActionIconEnum.BACK,
    },
    backListener: () => history.push(TypesRoutes.AFTER_SALES),
  })
  const filterTicketsToRedeem = useFilterTicketsToRedeem({ tickets: tickets.completed })
  const redemptionAmount = formatToBRL(tickets.totalRedemptionAmount ?? 0)

  const transactionAmount = formatToBRL(filterTicketsToRedeem.transactionAmount ?? 0)
  const transactionsCount = filterTicketsToRedeem.transactions ?? 0

  const message =
    filterTicketsToRedeem.transactions > 1
      ? `Em alguns minutos, você receberá ${transactionsCount} transações no valor de ${transactionAmount} cada uma.`
      : `Em alguns minutos, você receberá ${transactionsCount} transação no valor de ${transactionAmount}`

  useEffect(() => {
    analyticsRedeemLoad()
    monitoring({
      eventName: 'load_redeem_value_page',
      params: { redemption_amount: `${redemptionAmount}` },
    })
  }, [])

  const handleRedeemValue = () => {
    setShowRepurchaseChanceBS(true)
    monitoring({
      eventName: 'click_continue_redeem_button',
      params: {},
    })
    analyticsRedeemValueTag()
  }

  return (
    <S.Container>
      <S.IconWrapper data-testid="hand-money-icon">
        <Icons.HandMoney width={32} height={32} color="var(--gray500)" />
      </S.IconWrapper>
      <Text variant="headline-h1" semiBold>
        {redemptionAmount}
      </Text>
      <S.MessageWrapper>
        <Text variant="caption-1">{message}</Text>
      </S.MessageWrapper>
      <Separator type="dashed" borderWidth="1px" />
      <Flex direction="row" justifyContent="space-between">
        <Text variant="caption-1" colorWeight={400}>
          Forma de resgate
        </Text>
        <Text variant="caption-1" colorWeight={700} bold>
          Crédito em conta corrente
        </Text>
      </Flex>
      <S.FooterButton>
        <Button variant="primary" fullWidth onClick={handleRedeemValue}>
          Concluir resgate
        </Button>
      </S.FooterButton>

      <RepurchaseBottomSheet
        show={showRepurchaseChanceBS}
        onClose={() => setShowRepurchaseChanceBS(false)}
        onAccept={() => {
          setShowRepurchaseChanceBS(false)
          history.push(TypesRoutes.REPURCHASE)
        }}
        onDismiss={() => {
          setShowRepurchaseChanceBS(false)
          redeemValue({ history, pathname: TypesRoutes.REDEMPTION_RECEIPT })
        }}
      />
    </S.Container>
  )
}
